import React from 'react';
import ReactDOM from 'react-dom';
// import './estilo.css';
// import './t.js';

ReactDOM.render(
    
    document.getElementById('root')
);